import React, { useState, memo, useContext } from 'react';

import Dropzone from 'components/common/Dropzone/Dropzone';
import DocumentDropzoneArea from 'components/common/Dropzone/DocumentDropzoneArea/DocumentDropzoneArea';
import { ALLOWED_EXTENSIONS } from 'components/common/Dropzone/dropzone.constants';
import { handleFiles } from 'common/files/files.utils';
import SideBar from 'components/common/SideBar/SideBar';
import UploadInformational from 'components/common/UploadInformation/UploadInformational';
import { DocumentName, Status } from 'components/applications/applications.enums';
import { notify } from 'components/common/Toast/toast.helpers';
import { ToastMessage } from 'components/common/Toast/toast.enums';
import { RootStoreContext } from 'index';
import { ErrorMessage } from 'common/enums/errorMessages.enums';

import ConfirmationOfCorrectContract from './ConfirmationOfCorrectContract/ConfirmationOfCorrectContract';
import styles from './UploadContract.module.scss';

const ContractUploadSection = memo(() => {
  const { applicationsStore } = useContext(RootStoreContext);
  const { selectedApplication } = applicationsStore;
  const [files, setFiles] = useState<File[]>([]);
  const [isOpenConfirmationContractSidebar, setOpenConfirmationContractSidebar] = useState(false);
  const handleCloseConfirmationContractSidebar = () => {
    setOpenConfirmationContractSidebar(false);
  };
  const disabledDropZone = selectedApplication?.borrowerHomeImprovementEstimatesOrContractsStatus === Status.Confirmed;

  const handleContractFiles = async (uploadedFiles: File[]) => {
    const handledFiles = await handleFiles(uploadedFiles, DocumentName.ContractWorkOrder);

    setFiles(handledFiles);
    setOpenConfirmationContractSidebar(true);
  };

  const uploadContract = async () => {
    const success = await applicationsStore.uploadContract(selectedApplication?.id as string, files);

    if (success) {
      handleCloseConfirmationContractSidebar();
      notify(ToastMessage.UploadedDocument, 'success');
    } else {
      notify(ErrorMessage.UnknownError, 'error');
    }
  };

  return (
    <div>
      <h3 className={styles.title}>Upload Contract(s) Here</h3>
      <Dropzone extensions={ALLOWED_EXTENSIONS} disabled={disabledDropZone} onHandleFiles={handleContractFiles}>
        <DocumentDropzoneArea
          key={selectedApplication?.borrowerHomeImprovementEstimatesOrContractsStatus}
          status={selectedApplication?.borrowerHomeImprovementEstimatesOrContractsStatus}
        />
      </Dropzone>
      <SideBar
        title="I Hereby Affirm The Home Improvement Contract(s) Contain The Following:"
        isOpen={isOpenConfirmationContractSidebar}
        onClose={handleCloseConfirmationContractSidebar}
      >
        <ConfirmationOfCorrectContract onSubmit={uploadContract} />
      </SideBar>
      <UploadInformational />
    </div>
  );
});

export default ContractUploadSection;
